import type { MouseEvent } from 'react';

export type LinkClickEvent = Pick<
  MouseEvent,
  'defaultPrevented' | 'button' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'preventDefault'
>;

export const isPlainLeftClick = (e: LinkClickEvent): boolean =>
  !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

/**
 * Lets a real `<a href>` keep its native behaviour (new tab on cmd/ctrl/middle
 * click, open in window on shift, etc.) while a plain left click is routed to
 * the in-app `handler` instead — so crawlers see the link and SPA navigation /
 * selection logic is unchanged for users.
 */
export const interceptLinkClick = (e: LinkClickEvent, handler?: () => void): void => {
  if (!handler || !isPlainLeftClick(e)) return;
  e.preventDefault();
  handler();
};
